
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 112 97","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M112.105 64.805l-24.308 1.5L81.979.459 69.675 0l-2.76 69.338-27.28 6.933-9.28 2.998L26.7 36.583h-7.03l-2.83 47.308L0 96.82h31.41l-.861-12.841 12.708-3.687 23.5-4.427L65.51 96.82h24.467L88.22 73.625l23.974-1.27-.088-7.55zM78.815 9.507l3.709 57.433-11.144 1.764 3.252-58.685 4.183-.512zm-56.106 33.92l1.758-.141 1.178 37.394-4.64 1.57 1.704-38.823z","fill":"currentColor"}})])
          )
        }
      }
    